<template>
  <div>
    <logo-title
      :hotKeyWords="hotKeyWords"
      url="http://yingyu.xdf.cn/xinban/"
      logoPos="background-position: 4px -324px"
    ></logo-title>
    <!--<swiper
      title="英语学习"
      navCode="6"
      :consultList="consult"
      adCode=59
    ></swiper>-->
    <swiper></swiper>
    <keep-alive>
      <cart ></cart>
    </keep-alive>
    <main-floor></main-floor>
  </div>
</template>

<script>
import LogoTitle from '@/common-components/Logotitle'
import { hotKeyWords } from 'js/english/hotkeywords'
// import Swiper from '@/common-components/Swiper'
import Swiper from './components/swiper/Swiper'
import MainFloor from './components/mainfloor/Mainfloor'
import { consult } from 'js/english/consult.js'
import { englishMainNav } from 'js/english/mainnav'
import Cart from '@/common-components/Cart'
export default {
  name: 'univercity',
  data () {
    return {
      hotKeyWords,
      consult,
      englishMainNav
    }
  },
  components: {
    Cart,
    Swiper,
    LogoTitle,
    MainFloor
  }
}
</script>

<style lang="stylus"></style>



// WEBPACK FOOTER //
// src/pages/english/English.vue